import React from "react";

const CcList = ({ children, fullwidth = true }) => {
  const listStyle = (fullwidth) => ({
    listStyle: "none",
    padding: 5,
    margin: -5,
    columns: fullwidth ? 1 : 2,
    columnGap: fullwidth ? 0 : "6%",
    breakInside: "avoid",
    display: "flex",
    flexDirection: "row",
    flexBasis: "revert",
    flexWrap: "wrap",
    overflowY: "auto",
  });

  const listElementStyle = (fullwidth) => ({
    display: "inline-block",
    paddingBottom: 11,
    width: fullwidth ? "100%" : "47%",
  });

  return(
    <ul css={listStyle(fullwidth)}>
      {children?.map((child, key) => (
        <li key={key} css={listElementStyle(fullwidth)}>
          {child}
        </li>
      ))}
    </ul>
  );
};

export default CcList;

